module.exports = __webpack_public_path__ + "img/scammer.9a95a6f0.png";